export default angular.module("NewUserCtrl", []).controller("NewUserController", [
  "$scope",
  "$rootScope",
  "$http",
  "$state",
  "$filter",
  "System",
  "Users",
  "Permissions",
  function ($scope, $rootScope, $http, $state, $filter, System, Users, Permissions) {
    $rootScope.page = "users";
    $rootScope.userSelected = false;
    $scope.newUser = {
      RIGHTS: "0",
      accessRights: [],
      Organizations: [],
      allNations: false,
      allProviders: false,
    };
    $scope.countries = [
      {
        NAME: "-- Select country --",
        ABBREVIATION: "",
      },
    ];
    $scope.languages = [
      {
        NAME: "-- Select language --",
        ABBREVIATION: "",
      },
    ];
    $scope.getApplicationRightLevels = ({ APPLICATION }) =>
      Permissions.getRightLevelsForApplication(APPLICATION);

    $scope.accessRights = Permissions.applications
      .map(app => ({ APPLICATION: app, RIGHT_LEVEL: 0 }));

    System.loadCountries((data) => {
      $scope.countries = $scope.countries.concat(data);
      $scope.newUser.ESDE_COUNTRY = $scope.countries[0].ABBREVIATION;
    });

    System.loadLanguages((data) => {
      $scope.languages = $scope.languages.concat(data);
      $scope.newUser.ESDE_LANGUAGE = $scope.languages[0].ABBREVIATION;
    });

    $scope.loadContentGroupTags = function (query) {
      return $http
        .get("/api/contentprovidersname/", { cache: true })
        .then((response) => {
          const contents = response.data;
          return contents.filter(content => (
            content.LONG_NAME.toLowerCase().indexOf(query.toLowerCase()) !== -1
          ));
        });
    };

    $scope.loadNationalScriptsTags = function (query) {
      return $http
        .get("/api/countries/", { cache: true })
        .then((response) => {
          const countries = response.data;
          return countries.filter(country => (
            country.NAME.toLowerCase().indexOf(query.toLowerCase()) !== -1
          ));
        });
    };

    $scope.loadOrganizationTags = function (query) {
      return $http
        .get("/api/organizations/", { cache: true })
        .then((response) => {
          const contents = response.data;
          return contents.filter(content => (
            content.NAME.toLowerCase().indexOf(query.toLowerCase()) !== -1
          ));
        });
    };

    // Set starting day to monday
    $scope.calendarOptions = {
      "starting-day": "1",
    };

    $scope.calendarOpen = [];

    // Toggles the pop-up date picker for selecting start date.
    $scope.openCalendar = function ($event, index) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.calendarOpen[index] = !$scope.calendarOpen[index];
    };

    const buildSplitText = (split) => {
      if (!split || split.length === 0) {
        return "";
      }

      const texts = split.map(r => r.text).join(",");
      return `,${texts},`;
    };

    $scope.createUser = function () {
      $scope.newUser.CONTENT_GROUPS =
        $scope.newUser.allProviders ? ",All," : buildSplitText($scope.newUser.CONTENT_GROUPS_SPLITTED);
      $scope.newUser.NATIONAL_SCRIPTS =
        $scope.newUser.allNations ? ",All," : buildSplitText($scope.newUser.NATIONAL_SCRIPTS_SPLITTED);

      for (let i = 0; i < $scope.accessRights.length; i++) {
        const newRight = $scope.accessRights[i];
        if ($scope.accessRights[i].EXPIRATION_DATE) {
          newRight.EXPIRATION_DATE = $filter("date")(
            $scope.accessRights[i].EXPIRATION_DATE,
            "dd-MMM-yy",
          );
        }
        $scope.newUser.accessRights.push(newRight);
      }

      Users.saveNewUser($scope.newUser, (data, status) => {
        $scope.newUser.accessRights = [];
        if (status === 200) {
          $state.go("secured.users");
        }
      });
    };
  },
]);
